// React
import { ReactElement } from 'react';
// Modules
import { MixedCheckbox } from '@reach/checkbox';
import VisuallyHidden from '@reach/visually-hidden';
// Interface
import { RacesFilterProps } from '@utmb/types/start-list-table';
import { IconsEnum } from '@utmb/types/icons';
// Design System
import { DropDown, DropDownItem } from '@utmb/design-system/dropdown/Dropdown';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { Separator } from '@utmb/design-system/separator/Separator';
// Utils
import { rem } from '@utmb/utils/font';
// Styles
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';
import { PiCategoryLogo } from '@utmb/design-system/pi-category-logo/PiCategoryLogo';

const RacesFilter = (props: RacesFilterProps): ReactElement => {
    const { currentRaces, races, setCurrentRaces } = props;
    const { t } = useTranslation();
    const handleInputRacesChange = (races: any): void => {
        if (races !== currentRaces) {
            setCurrentRaces(races);
        } else {
            setCurrentRaces('');
        }
    };

    const currentRacesView = races.find((raceView) => raceView.strapiId.toString() === currentRaces.toString());

    return (
        <div className={styles.toolbar}>
            <DropDown
                className={styles.drop}
                button={({ isExpanded }) => (
                    <>
                        <Font.OxaniumMedium mobile="14" desktop="14" className={styles.filter_label} as={'span'}>
                            {currentRaces && currentRacesView ? (
                                <div className={styles.label_content}>
                                    <PiCategoryLogo height={16} piCategory={currentRacesView.raceView?.category as PiCategoryEnum} />
                                    <span>{currentRacesView.raceView?.name}</span>
                                </div>
                            ) : (
                                t('registeredList.race')
                            )}
                            {/**t('registeredList.race')*/}
                        </Font.OxaniumMedium>
                        <Icon color={'var(--utmb-color-ws-primary)'} variant={IconsEnum[isExpanded ? 'CHEVRON_UP' : 'CHEVRON_DOWN']} />
                    </>
                )}
            >
                {Object.entries(races).map(([key, raceView], index: number) => {
                    const checked = raceView.strapiId.toString() === currentRaces;

                    const hasSeparator = index < Object.entries(races).length - 1;

                    return (
                        <div key={index} className={styles.item_wrapper}>
                            <DropDownItem onSelect={() => handleInputRacesChange(raceView.strapiId.toString())} className={styles.item}>
                                <Font.OxaniumMedium className={styles.country_filter_option} mobile="14" desktop="14" as="span">
                                    <PiCategoryLogo height={20} piCategory={raceView.raceView?.category as PiCategoryEnum} /> {raceView.raceView?.name}
                                </Font.OxaniumMedium>
                                <label>
                                    <MixedCheckbox value={raceView.strapiId.toString()} checked={true} />
                                    {checked && <Icon variant={IconsEnum.CHECKBOX} color="rgba(65, 80, 92,.8)" />}
                                    <VisuallyHidden> {key}</VisuallyHidden>
                                </label>
                            </DropDownItem>
                            {hasSeparator && <Separator color="rgba(65, 80, 92,.2)" spacing="0 auto" depth={`calc(100% - ${rem('15px')})`} />}
                        </div>
                    );
                })}
            </DropDown>
        </div>
    );
};

export default RacesFilter;
